/* eslint-disable sonarjs/no-duplicate-string */
import superagent from "superagent";
import Cookies from "universal-cookie";
import { base_url } from "../../../../utils/constants";
import { DELETE_ANNOUNCEMENT, GET_ANNOUNCEMENT, GET_EXPIRED_ANNOUNCEMENTS, SET_ANNOUNCEMENT_LOADER } from "./constants";
import { THROW_ERROR, THROW_SUCCESS } from "../../../../store/constants";

const cookie = new Cookies();

const clearSession = () => {
  cookie.remove("user_token");
  cookie.remove("user_info");
  window.location.replace("/admin");
};

const createAnnouncementObj = (resObj: any) => {
  return {
    id: resObj?.id || "",
    announcement: resObj?.title || "",
    date: resObj?.end_date || "",
    time: resObj?.end_time || "",
    color: resObj?.bg_color || "",
    link: resObj?.link || "",
    timer: resObj?.show_timer ? 1 : 0,
  };
};

export const getAnnouncement = (setpageLoader?: any) => (dispatch: any) => {
  try {
    return superagent
      .get(`${base_url}get-announcement-data`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((_err, res) => {
        dispatch({ type: SET_ANNOUNCEMENT_LOADER, payload: false });
        if (res?.body?.status) {
          dispatch({ type: GET_ANNOUNCEMENT, payload: createAnnouncementObj(res?.body?.data) });
        }
        setpageLoader?.(false);
      });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error from get-announcement-data", error);
    dispatch({ type: SET_ANNOUNCEMENT_LOADER, payload: false });
    setpageLoader?.(false);
    return null;
  }
};

export const getExpiredAnnouncements = (setLoader?: any) => (dispatch: any) => {
  try {
    return superagent
      .get(`${base_url}admin/get-all-announcements`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((_err, res) => {
        if (res?.body?.status) {
          dispatch({ type: GET_EXPIRED_ANNOUNCEMENTS, payload: res?.body?.data });
          setLoader?.(false);
        } else {
          setLoader?.(false);
        }
        if (res?.body?.message === "Unauthenticated.") {
          clearSession();
        }
      });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error from get-all-announcements", error);
    return null;
  }
};

export const addAnnouncement = (data: any, setEditView: any, setLoading: any, history?: any) => (dispatch: any) => {
  return (
    superagent
      .post(`${base_url}admin/save-announcement`)
      .send(data)
      // eslint-disable-next-line sonarjs/no-duplicate-string
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        if (res) {
          setLoading(false);
          setEditView(false);
          dispatch(getAnnouncement());
          dispatch(getExpiredAnnouncements());
          if (res.status === 200) {
            history?.push("list-announcement");
            dispatch({ type: THROW_SUCCESS, payload: res?.body?.message });
          } else {
            dispatch({ type: THROW_ERROR, payload: res?.body?.message });
          }
          if (res?.body?.message === "Unauthenticated.") {
            clearSession();
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: err?.data?.message });
        }
      })
  );
};

export const deleteAnnouncement = (setActiveForm: any, setLoading: any, setShow: any, setEditView: any, history: any) => (dispatch: any) => {
  return (
    superagent
      .delete(`${base_url}admin/delete-announcement`)
      // eslint-disable-next-line sonarjs/no-duplicate-string
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        if (res) {
          if (res.status) {
            setLoading(false);
            setShow(false);
            setActiveForm(false);
            setEditView(false);
            history.push("list-announcement");
            dispatch(getAnnouncement());
            dispatch(getExpiredAnnouncements());
            dispatch({ type: DELETE_ANNOUNCEMENT, payload: null });
            dispatch({ type: THROW_SUCCESS, payload: res?.body?.message });
            if (res?.body?.message === "Unauthenticated.") {
              clearSession();
            }
          } else {
            dispatch({ type: THROW_ERROR, payload: res?.body?.message });
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: err?.data?.message });
        }
      })
  );
};
